import { HTTPClient } from "./Client";


const HomeApi = {
    async ListarTurmaPorPessoaAsync() {
        const response = await HTTPClient.get(`/PessoaTurma/ListarTurmaPorPessoa`);
        return response.data;
    },

    async ListarTurmasComQuantidadeAlunosAsync() {
        const response = await HTTPClient.get(`/PessoaTurma/ListarTurmasComQuantidadeAlunos`);
        return response.data;
    },

    async ListarProgressoCursosModle() {
        const response = await HTTPClient.get(`/Moodle/BuscarCursosPorIdUsuario`);
        
        return response.data;
    },

}

export default HomeApi;